import type { Option } from "@src/lib/ui/toggleOption";
import CardsOutlineIcon from "@src/lib/icons/18px/cards-outline";
import GridOutlineIcon from "@src/lib/icons/18px/grid-outline";
import { useMemo } from "react";
import { createEnumParam, useQueryParam, withDefault } from "use-query-params";

// "small-screens" (the old Overview) is still parsed so existing links keep
// working, but it now renders as the grid: the grid's Screen size slider
// covers both the Overview and the old Grid view sizes.
export type ViewMode = "small-screens" | "medium-screens" | "full-screen";
export const VIEW_MODE_OPTIONS: Option<ViewMode>[] = [
  {
    label: "Grid view",
    value: "medium-screens",
    icon: <GridOutlineIcon className="size-4" />,
  },
  {
    label: "Fullscreen",
    value: "full-screen",
    icon: <CardsOutlineIcon className="size-4" />,
  },
];

const PARSED_VIEW_MODES: ViewMode[] = [
  "small-screens",
  "medium-screens",
  "full-screen",
];

type Return = {
  viewMode: ViewMode | null | undefined;
  setViewMode: (value: ViewMode) => void;
};

const useViewModeQueryParams = (): Return => {
  const [viewMode, setViewMode] = useQueryParam(
    "view-mode",
    withDefault(createEnumParam<ViewMode>(PARSED_VIEW_MODES), "medium-screens"),
  );
  return useMemo(() => {
    return {
      viewMode: viewMode === "small-screens" ? "medium-screens" : viewMode,
      setViewMode,
    };
  }, [viewMode, setViewMode]);
};

export default useViewModeQueryParams;
